var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_200 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.256836 7.05469C0.256836 6.74403 0.508676 6.49219 0.819336 6.49219H14.1873C14.498 6.49219 14.7498 6.74403 14.7498 7.05469C14.7498 7.36535 14.498 7.61719 14.1873 7.61719H0.819336C0.508676 7.61719 0.256836 7.36535 0.256836 7.05469Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_201 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.269 9.98438C10.269 9.67371 10.5209 9.42188 10.8315 9.42188H10.8385C11.1492 9.42188 11.401 9.67371 11.401 9.98438C11.401 10.295 11.1492 10.5469 10.8385 10.5469H10.8315C10.5209 10.5469 10.269 10.295 10.269 9.98438Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_202 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94092 9.98438C6.94092 9.67371 7.19276 9.42188 7.50342 9.42188H7.51037C7.82103 9.42188 8.07287 9.67371 8.07287 9.98438C8.07287 10.295 7.82103 10.5469 7.51037 10.5469H7.50342C7.19276 10.5469 6.94092 10.295 6.94092 9.98438Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_203 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60596 9.98438C3.60596 9.67371 3.8578 9.42188 4.16846 9.42188H4.17541C4.48607 9.42188 4.73791 9.67371 4.73791 9.98438C4.73791 10.295 4.48607 10.5469 4.17541 10.5469H4.16846C3.8578 10.5469 3.60596 10.295 3.60596 9.98438Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_204 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.269 12.8984C10.269 12.5878 10.5209 12.3359 10.8315 12.3359H10.8385C11.1492 12.3359 11.401 12.5878 11.401 12.8984C11.401 13.2091 11.1492 13.4609 10.8385 13.4609H10.8315C10.5209 13.4609 10.269 13.2091 10.269 12.8984Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_205 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94092 12.8984C6.94092 12.5878 7.19276 12.3359 7.50342 12.3359H7.51037C7.82103 12.3359 8.07287 12.5878 8.07287 12.8984C8.07287 13.2091 7.82103 13.4609 7.51037 13.4609H7.50342C7.19276 13.4609 6.94092 13.2091 6.94092 12.8984Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_206 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60596 12.8984C3.60596 12.5878 3.8578 12.3359 4.16846 12.3359H4.17541C4.48607 12.3359 4.73791 12.5878 4.73791 12.8984C4.73791 13.2091 4.48607 13.4609 4.17541 13.4609H4.16846C3.8578 13.4609 3.60596 13.2091 3.60596 12.8984Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_207 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5327 0.9375C10.8434 0.9375 11.0952 1.18934 11.0952 1.5V3.96809C11.0952 4.27875 10.8434 4.53059 10.5327 4.53059C10.2221 4.53059 9.97021 4.27875 9.97021 3.96809V1.5C9.97021 1.18934 10.2221 0.9375 10.5327 0.9375Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_208 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47412 0.9375C4.78478 0.9375 5.03662 1.18934 5.03662 1.5V3.96809C5.03662 4.27875 4.78478 4.53059 4.47412 4.53059C4.16346 4.53059 3.91162 4.27875 3.91162 3.96809V1.5C3.91162 1.18934 4.16346 0.9375 4.47412 0.9375Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32562 3.1752C2.07686 2.46107 3.12564 2.125 4.32822 2.125H10.6787C11.8843 2.125 12.9336 2.46082 13.6836 3.17574C14.4378 3.89468 14.8161 4.92729 14.8125 6.17055V13.0137C14.8125 14.257 14.4322 15.2907 13.6779 16.011C12.9275 16.7275 11.8783 17.0656 10.6718 17.0656H4.32822C3.12226 17.0656 2.07227 16.7205 1.32169 15.993C0.568305 15.2628 0.1875 14.2162 0.1875 12.957V6.16977C0.1875 4.92565 0.570029 3.89346 1.32562 3.1752ZM2.10072 3.99058C1.61782 4.44962 1.3125 5.15857 1.3125 6.16977V12.957C1.3125 13.9886 1.61955 14.715 2.10465 15.1852C2.59255 15.6581 3.33167 15.9406 4.32822 15.9406H10.6718C11.6747 15.9406 12.4146 15.6617 12.901 15.1973C13.3833 14.7368 13.6875 14.0258 13.6875 13.0137V6.16977L13.6875 6.16804C13.6906 5.1564 13.388 4.44822 12.9074 3.99004C12.4223 3.52766 11.6826 3.25 10.6787 3.25H4.32822C3.32829 3.25 2.58796 3.5274 2.10072 3.99058Z",
    fill: "#221AFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.4170672c3df954dbdd6d5d5d09e5e3ac.svg";
export { ForwardRef as ReactComponent };